import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect, useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Language } from "../../redux/store/base/language";
import { getLanguages, setLanguage } from "../../redux/actions/language.action";

import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBCollapse,
  MDBRow,
  MDBCol,
  MDBHamburgerToggler,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
} from "mdbreact";
import {
  faSearch,
  faEllipsisV,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

import Logo from "./../../assets/images/Logo-White.svg";
import Marker from "./../../assets/images/Icons/Links/Location Marker.svg";
import CreditCard from "./../../assets/images/Icons/Links/Credit Card.svg";
import ChatDots from "./../../assets/images/Icons/Links/Chat Dots.svg";
import Bell from "./../../assets/images/Icons/Links/Bell.svg";

import "./NavbarPage.scss";
import { navigate } from "gatsby";

interface NavbarPageProps {}
const NavbarPage = (props: NavbarPageProps) => {
  const dispatch = useDispatch();
  const lang = useSelector((state: { lang: Language }) => state.lang);

  const [collapse, setCollapse] = useState(false);

  const onClick = () => {
    setCollapse(!collapse);
  };

  const Navgate = (path: string) => navigate(`/${path}`);

  return (
    <MDBNavbar className="p-0 py-2" sticky={"top"} dark expand="md" scrolling>
      <MDBContainer fluid>
        <MDBRow className="w-100">
          <MDBCol
            lg={"3"}
            md={"3"}
            sm={"12"}
            className="text-center m-md-auto mr-sm-0 ml-auto"
          >
            <MDBNavbarBrand
              className="m-0 pointer"
              onClick={() => Navgate("home")}
            >
              <img
                src={Logo}
                alt="logo"
                className="m-0"
                width={40}
                height={40}
              />
              <img src={Marker} className="d-inline-inline mr-3 ml-1" />
              <span>تبوك - الرياض</span>
            </MDBNavbarBrand>

            <MDBHamburgerToggler
              id="nav"
              className="mr-auto d-md-none d-sm-block"
              onClick={onClick}
            />
          </MDBCol>

          <MDBCollapse isOpen={collapse} navbar className="pt-md-0 pt-sm-3">
            <MDBCol
              lg={"8"}
              md={"6"}
              sm={"10"}
              className="text-center mx-lg-0 mx-md-0 m-auto pl-lg-0 order-md-1 order-sm-2"
            >
              <div className="input-group md-form form-sm form-1 pl-0">
                <input
                  className="form-control my-0 py-1"
                  type="text"
                  placeholder={lang.dictionary?.searchPlaceholder}
                  aria-label="Search"
                />
                <div className="input-group-append">
                  <span className="input-group-text">
                    <FontAwesomeIcon
                      icon={faSearch}
                      className="d-inline-inline mx-3"
                    />{" "}
                  </span>
                </div>
              </div>
            </MDBCol>

            <MDBCol
              lg={"4"}
              md={"6"}
              sm={"12"}
              className="text-center d-flex mr-auto  order-md-2 order-sm-1"
            >
              <div className="my-auto">
                <img src={CreditCard} className="mx-1" />
                <span className="money">543.4 ريال</span>
              </div>
              <img src={ChatDots} className="my-auto mx-2" />
              <img src={Bell} className="my-auto mx-2" />
              <MDBDropdown>
                <MDBDropdownToggle color="primary" className="my-auto lang">
                  <FontAwesomeIcon icon={faGlobe} />
                  {
                    lang?.languages?.find(id =>
                      id.id.match(lang.caruentLanguage.id)
                    )?.text
                  }
                </MDBDropdownToggle>
                <MDBDropdownMenu flip>
                  {lang?.languages
                    ?.filter(id => !id.id.match(lang.caruentLanguage.id))
                    .map((item: { id: string; text: string }, i) => (
                      <MDBDropdownItem
                        key={item.id}
                        onClick={() => dispatch(setLanguage(item.id))}
                      >
                        {item.text}
                      </MDBDropdownItem>
                    ))}
                </MDBDropdownMenu>
              </MDBDropdown>
              <div className="avatar my-auto mr-auto">
                <img src={Logo} alt="Rooh" />
              </div>
              <FontAwesomeIcon icon={faEllipsisV} className="my-auto mr-2" />
            </MDBCol>
          </MDBCollapse>
        </MDBRow>
      </MDBContainer>
    </MDBNavbar>
  );
};

export default NavbarPage;
